module.exports = __webpack_public_path__ + "static/media/upload-csv.fa52d5cd.png";